import React, { useState, useEffect } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import { ApiServiceServerless } from '../../xhr_libs';

const styles = {
  button: {
    position: 'absolute',
    bottom: '1em',
    right: '2em',
  },
  alert: {
    padding: '1em',
  },
};

export default function CheckResources(props) {
  const { dashboardData, organization } = props;
  const [statusState, setStatusState] = useState(0);

  const history = useHistory();

  const get_dashboard_status = (org_id) => {
    ApiServiceServerless.get(`/dashboard/status/${org_id}`, {
      authorization_id: org_id,
    }).then((res) => {
      const data = res.data;
      if (data.buildings === 0) {
        setStatusState(2);
      } else if (data.accounts === 0) {
        setStatusState(3);
      } else {
        setStatusState(4);
      }
    });
  };

  useEffect(() => {
    if (dashboardData['month_array'].length === 0) {
      if (organization.id) {
        get_dashboard_status(organization.id);
      } else {
        setStatusState(1);
      }
    } else {
      setStatusState(0);
    }
  }, [dashboardData, organization]);

  switch (statusState) {
    case 1:
      return (
        <Alert variant='primary' style={styles.alert}>
          It looks like you do not have any organizations yet.
          <Button
            style={styles.button}
            variant='success'
            onClick={() => history.push('/organizations')}
          >
            New Organization
          </Button>
        </Alert>
      );
    case 2:
      return (
        <Alert variant='primary' style={styles.alert}>
          It looks like this organization does not have any buildings yet.
          <Button
            style={styles.button}
            variant='success'
            onClick={() => history.push('/accounts')}
          >
            New Building
          </Button>
        </Alert>
      );
    case 3:
      return (
        <Alert variant='primary' style={styles.alert}>
          It looks like this organization does not have any utility accounts
          yet.
          <Button
            style={styles.button}
            variant='success'
            onClick={() => history.push('/accounts')}
          >
            New Account
          </Button>
        </Alert>
      );
    case 4:
      return (
        <Alert variant='primary' style={styles.alert}>
          There were no bills found for this organization and time period
          <Button
            style={styles.button}
            variant='success'
            onClick={() => history.push('/accounts')}
          >
            Check Bills
          </Button>
        </Alert>
      );
    default:
      return <></>;
  }
}
